module.exports = __webpack_public_path__ + "media/images/lb/301-3b924423ba2bb42470da8001c04a3f2a.svg";